/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('MessageTemplates', function ($scope, templateService, mailboxService, $rootScope, $http,
        _$privileges,$mdDialog) {
    $scope.showLoader=false;
    $scope.rows = [];
    $rootScope.checkboxList.clear();
    
    $scope.data = {
        "can_write": _$privileges.write("message"),
        "copy_template_name": ""
    };            

    /*
     * pagination
     */

    $scope.pagination = {
        currentPage: 1,
        totalItems: 1,
        itemsPerPage: 1
    };

    $scope.setPage = function () {
        $scope.list($scope.pagination.currentPage);
    };

    $scope.list = function (page) {
        var filter = {
            "notification_category_id": $scope.search.filter.notification_category_id.value!=null ? $scope.search.filter.notification_category_id.value.join() : "",
            "notification_id": $scope.search.filter.notification_id.value!=null ? $scope.search.filter.notification_id.value.join() : "",
            "user": $scope.search.filter.user.value
        };

        $scope.showLoader=true;

        var promise = templateService.list(page, filter);
        promise.then(
                function (payload) {
                    $scope.showLoader=false;
                    $scope.rows = payload.data.data;
                    $scope.pagination = {
                        totalItems: payload.data.total,
                        currentPage: payload.data.current_page,
                        itemsPerPage: payload.data.per_page
                    };
                },
                function (errorPayload) {
                    $rootScope.notification.show('error', 'Błąd ładowania szablonów');
                });
    };

    $scope.search = {
        "data": {},
        "get": function () {
            $scope.showLoader=true;
            var promise = mailboxService.filter();
            promise.then(
                    function (payload) {
                        $scope.showLoader=false;
                        $scope.search.data = payload.data;
                    },
                    function (errorPayload) {
                        $rootScope.notification.show('error', 'Błąd ładowania filtrów wyszukiwania skrzynki wiadomości');
                    });
        },
        "filter": {
            "notification_category_id": {
                value: []
            },
            "mailbox_state_id": {
                value: []
            },
            "notification_id": {
                value: []
            },
            "user": {
                value: "",
            }
        }
    };

    $scope.list(1);
    $scope.search.get();

    $scope.panel = {
        "show": function(){
            
        },
        "concate": function(){
            var ids = [];
            for(var i=0; i<$scope.rows.length;i++){
                if($scope.rows[i].checked)
                    ids.push($scope.rows[i].id);
            }
            return ids;
        },
        "delete": function () {
            var promise = templateService.delete($scope.panel.concate());
            promise.then(
                    function (payload) {
                        if (payload.data.code == 1) {
                            $rootScope.notification.show('success', payload.data.msg);
                            $scope.list(1);
                            $rootScope.checkboxList.clear();
                        } else {
                            $rootScope.notification.show('error', payload.data.msg);
                        }
                    });
        },
        "copy" : {
            "name": "",
            "show": function () {                
                var parentEl = angular.element(document.body);
                $mdDialog.show({
                    parent: parentEl,      
                    controller: function () { this.parent = $scope; },
                    controllerAs: 'ctrl',
                    templateUrl: "/assets/js/angular/message/views/modal/template_copy.html?v=2"                    
                });
            },
            "commit": function () {                
                var promise = templateService.copy({
                    "id": $scope.panel.concate()[0],
                    "name": $scope.panel.copy.name
                });
                promise.then(
                        function (payload) {
                            $rootScope.notification.show(payload.data.code ? 'success' : 'error', payload.data.msg);
                            if (payload.data.code) {
                                $scope.list(1);
                                $rootScope.checkboxList.clear();
                            }
                            $scope.panel.copy.name = "";
                        });
                $mdDialog.hide();
            },
            "cancel": function () {
                $mdDialog.cancel();
            }
        }
    };

    $scope.onFilter = function () {

    };


    $scope.queryAssign = function (search) {
        return $http.get("/user?search=" + search).then(function (results) {
            return results.data;
        });
    };

    $scope.clearFilters = function () {
        $scope.search.filter.notification_category_id.value = [];
        $scope.search.filter.mailbox_state_id.value = [];
        $scope.search.filter.notification_id.value = []
        $scope.search.filter.user.value = "",
        $scope.list(1);
    };
});
                                    